(() => {
  const body = document.body;
  const menu = document.querySelector('[data-mobile-menu]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  let searchTimer;

  const lockBody = () => {
    const open = document.querySelector('.mobile-menu.is-open, .search-overlay.is-open, .cart-drawer.is-open');
    body.style.overflow = open ? 'hidden' : '';
  };

  const setMenu = (open) => {
    if (!menu || !menuToggle) return;
    menu.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    lockBody();
  };

  const setSearch = (open) => {
    if (!searchOverlay) return;
    searchOverlay.classList.toggle('is-open', open);
    searchOverlay.setAttribute('aria-hidden', String(!open));
    lockBody();
    if (open) setTimeout(() => searchInput?.focus(), 120);
  };

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format((cents || 0) / 100);

  const renderCart = (cart) => {
    const items = document.querySelector('[data-cart-items]');
    const count = document.querySelector('[data-cart-count]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (count) { count.textContent = cart.item_count; count.classList.toggle('is-empty', cart.item_count === 0); }
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🛍️</div><h3>Your cart is empty</h3><p>Discover useful finds made for everyday life.</p><a class="btn btn--primary" href="/collections/all">Start shopping</a></div>';
      return;
    }
    items.innerHTML = cart.items.map((item, index) => `
      <article class="cart-line" data-line="${index + 1}">
        <a href="${item.url}" class="cart-line__image">${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}">` : ''}</a>
        <div class="cart-line__content">
          <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-line__variant">${item.variant_title}</span>` : ''}
          <strong>${money(item.final_line_price)}</strong>
          <div class="cart-line__controls">
            <button type="button" data-cart-minus aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-plus aria-label="Increase quantity">+</button>
            <button type="button" class="cart-line__remove" data-cart-remove>Remove</button>
          </div>
        </div>
      </article>`).join('');
  };

  const refreshCart = async () => {
    try { renderCart(await fetch('/cart.js').then(r => r.json())); } catch (e) { console.error(e); }
  };

  const setCart = async (open) => {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-open', open);
    cartDrawer.setAttribute('aria-hidden', String(!open));
    lockBody();
    if (open) await refreshCart();
  };

  menuToggle?.addEventListener('click', () => setMenu(true));
  document.querySelectorAll('[data-menu-close]').forEach(el => el.addEventListener('click', () => setMenu(false)));
  document.querySelectorAll('[data-search-open]').forEach(el => el.addEventListener('click', () => setSearch(true)));
  document.querySelectorAll('[data-search-close]').forEach(el => el.addEventListener('click', () => setSearch(false)));
  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', () => setCart(true)));
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', () => setCart(false)));

  document.querySelectorAll('[data-desktop-dropdown]').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      const item = button.closest('.nav__item');
      const willOpen = !item.classList.contains('is-open');
      document.querySelectorAll('.nav__item.is-open').forEach(openItem => {
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-desktop-dropdown]')?.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', String(willOpen));
    });
  });

  document.querySelectorAll('[data-mobile-dropdown]').forEach(button => {
    button.addEventListener('click', () => {
      const submenu = button.nextElementSibling;
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (submenu) submenu.hidden = open;
    });
  });

  document.addEventListener('click', event => {
    if (!event.target.closest('.nav__item')) {
      document.querySelectorAll('.nav__item.is-open').forEach(item => {
        item.classList.remove('is-open');
        item.querySelector('[data-desktop-dropdown]')?.setAttribute('aria-expanded', 'false');
      });
    }
  });

  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults.innerHTML = '<p class="search-results__hint">Start typing to discover Trend & Treasure products.</p>'; return; }
    searchResults.innerHTML = '<p class="search-results__hint">Searching…</p>';
    searchTimer = setTimeout(async () => {
      try {
        const data = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`).then(r => r.json());
        const products = data.resources?.results?.products || [];
        if (!products.length) { searchResults.innerHTML = `<p class="search-results__hint">No products found for “${q}”.</p>`; return; }
        searchResults.innerHTML = `<div class="predictive-grid">${products.map(product => `<a href="${product.url}" class="predictive-product"><span class="predictive-product__image">${product.image ? `<img src="${product.image}" alt="">` : ''}</span><span><strong>${product.title}</strong><small>${product.price}</small></span></a>`).join('')}</div><a class="search-view-all" href="/search?q=${encodeURIComponent(q)}&type=product">View all results</a>`;
      } catch (e) { searchResults.innerHTML = '<p class="search-results__hint">Search is temporarily unavailable.</p>'; }
    }, 250);
  });

  cartDrawer?.addEventListener('click', async (event) => {
    const line = event.target.closest('[data-line]');
    if (!line) return;
    const current = Number(line.querySelector('.cart-line__controls span')?.textContent || 1);
    let quantity = null;
    if (event.target.closest('[data-cart-minus]')) quantity = Math.max(0, current - 1);
    if (event.target.closest('[data-cart-plus]')) quantity = current + 1;
    if (event.target.closest('[data-cart-remove]')) quantity = 0;
    if (quantity === null) return;
    event.target.disabled = true;
    try {
      const cart = await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ line: Number(line.dataset.line), quantity }) }).then(r => r.json());
      renderCart(cart);
    } catch (e) { console.error(e); }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) { button.disabled = true; button.dataset.originalText = button.textContent; button.textContent = 'Adding…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: {'Accept':'application/json'}, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add item');
      await setCart(true);
    } catch (e) { form.submit(); }
    finally { if (button) { button.disabled = false; button.textContent = button.dataset.originalText || 'Add to cart'; } }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setMenu(false); setSearch(false); setCart(false);
  });
})();

// V11 cart page quantity controls
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cart-page-line').forEach((line) => {
    const input = line.querySelector('[data-cart-page-input]');
    if (!input) return;
    line.querySelector('[data-cart-page-minus]')?.addEventListener('click', () => {
      input.value = Math.max(0, Number(input.value || 1) - 1);
    });
    line.querySelector('[data-cart-page-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 0) + 1;
    });
  });
});

// V16 product page gallery, quantity, tabs, variant price and lightbox
window.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const slides = [...root.querySelectorAll('[data-product-slide]')];
  const thumbs = [...root.querySelectorAll('[data-product-thumb]')];
  let active = 0;
  const show = (index) => {
    if (!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === active));
  };
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(Number(thumb.dataset.productThumb))));
  root.querySelector('[data-product-prev]')?.addEventListener('click', () => show(active - 1));
  root.querySelector('[data-product-next]')?.addEventListener('click', () => show(active + 1));
  document.addEventListener('keydown', (event) => {
    if (!root.matches(':focus-within') && window.innerWidth > 760) return;
    if (event.key === 'ArrowLeft') show(active - 1);
    if (event.key === 'ArrowRight') show(active + 1);
  });

  const quantity = root.querySelector('[data-product-quantity]');
  root.querySelector('[data-product-minus]')?.addEventListener('click', () => quantity.value = Math.max(1, Number(quantity.value || 1) - 1));
  root.querySelector('[data-product-plus]')?.addEventListener('click', () => quantity.value = Number(quantity.value || 1) + 1);

  root.querySelectorAll('[data-tab-button]').forEach((button) => button.addEventListener('click', () => {
    root.querySelectorAll('[data-tab-button]').forEach((item) => item.classList.toggle('is-active', item === button));
    root.querySelectorAll('[data-tab-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tabPanel === button.dataset.tabButton));
  }));

  const select = root.querySelector('[data-variant-select]');
  const showVariantMedia = (option) => {
    const mediaId = option?.dataset?.mediaId;
    if (!mediaId) return;
    const matchingSlide = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
    if (matchingSlide >= 0) {
      show(matchingSlide);
      thumbs[matchingSlide]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  };
  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    showVariantMedia(option);
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
  });
  if (select) showVariantMedia(select.selectedOptions[0]);

  const lightbox = document.querySelector('[data-product-lightbox]');
  root.querySelector('[data-product-zoom]')?.addEventListener('click', () => {
    const image = slides[active]?.querySelector('img');
    if (!image || !lightbox) return;
    lightbox.querySelector('img').src = image.currentSrc || image.src;
    lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false');
  });
  lightbox?.querySelector('[data-product-lightbox-close]')?.addEventListener('click', () => { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); });
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); } });
});

// V18 You May Also Like carousel: 8 visible on desktop, 4 tablet, 2 mobile
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-related-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-related-track]');
    const items = [...carousel.querySelectorAll('.product-related__item')];
    const prev = carousel.querySelector('[data-related-prev]');
    const next = carousel.querySelector('[data-related-next]');
    if (!track || !items.length) return;
    let index = 0;
    const visibleCount = () => window.innerWidth <= 760 ? 2 : (window.innerWidth <= 1050 ? 4 : 8);
    const maxIndex = () => Math.max(0, items.length - visibleCount());
    const update = () => {
      index = Math.min(index, maxIndex());
      const first = items[0];
      const gap = parseFloat(getComputedStyle(track).gap || 0);
      const step = first.getBoundingClientRect().width + gap;
      track.style.transform = `translate3d(${-index * step}px,0,0)`;
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
    };
    prev?.addEventListener('click', () => { index = Math.max(0, index - visibleCount()); update(); });
    next?.addEventListener('click', () => { index = Math.min(maxIndex(), index + visibleCount()); update(); });
    let resizeTimer;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(update, 100); });
    update();
  });
});

// V20 Shopify Product Recommendations API loader
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initializeCarousel();
          }
        })
        .catch(() => {});
    }

    initializeCarousel() {
      const carousel = this.querySelector('[data-related-carousel]');
      if (!carousel) return;
      const track = carousel.querySelector('[data-related-track]');
      const items = [...carousel.querySelectorAll('.product-related__item')];
      const prev = carousel.querySelector('[data-related-prev]');
      const next = carousel.querySelector('[data-related-next]');
      if (!track || !items.length || !prev || !next) return;
      let index = 0;
      const perView = () => window.innerWidth <= 760 ? 2 : window.innerWidth <= 1050 ? 4 : 8;
      const maxIndex = () => Math.max(0, items.length - perView());
      const update = () => {
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const itemWidth = items[0].getBoundingClientRect().width;
        track.style.transform = `translateX(-${index * (itemWidth + gap)}px)`;
        prev.disabled = index <= 0;
        next.disabled = index >= maxIndex();
      };
      prev.addEventListener('click', () => { index = Math.max(0, index - perView()); update(); });
      next.addEventListener('click', () => { index = Math.min(maxIndex(), index + perView()); update(); });
      window.addEventListener('resize', () => { index = Math.min(index, maxIndex()); update(); });
      update();
    }
  });
}
